import { useQuery } from 'react-query'
import { request } from '../api/apiCore'

const fetchAreas = () => request({ url: '/admin/areas.json' })

export const useAreasData = () => useQuery('areas', fetchAreas)

const fetchAreaById = areaId => request({ url: `/admin/areas/${areaId}.json`, method: 'GET' })
export const useAreaData = id => useQuery('areas', () => fetchAreaById(id))
